import { observable, flow } from 'mobx'
import { get } from 'common/src/vtj/browser/http'
import { Serialized } from 'common/src/vtj/types/util.type'
import { TodistusPyyntöAetOverview } from 'todistukset-common/src/vtj/types/todistus'

export type AetTodistuspyynnotStore = {
  isLoading: boolean
  error: Error | null
  loadAetTodistuspyynnot: () => void
  aetOrders: Serialized<TodistusPyyntöAetOverview>[]
}

export const createAetTodistuspyynnotStore = (
  initialAetOrders: Serialized<TodistusPyyntöAetOverview>[]
): AetTodistuspyynnotStore => {
  const todistuspyynotStore: AetTodistuspyynnotStore = observable({
    isLoading: false,
    aetOrders: initialAetOrders,
    error: null,
    loadAetTodistuspyynnot: flow(function* () {
      if (todistuspyynotStore.isLoading) {
        return
      }
      todistuspyynotStore.isLoading = true
      todistuspyynotStore.error = null
      todistuspyynotStore.aetOrders = []
      const [err, response] = yield get(
        '/api/restricted/todistukset/aet/orders'
      )
      todistuspyynotStore.isLoading = false
      if (err) {
        todistuspyynotStore.error = err
      } else {
        todistuspyynotStore.aetOrders = response.data.aetOrders
      }
    }),
  })
  return todistuspyynotStore
}
